import { getOverflowParents } from '../internal/utils/scrollable-containers';
export default function stickyScrolling(containerRef, stickyRef) {
    var scrollToTop = function () {
        if (!containerRef.current || !stickyRef.current) {
            return;
        }
        var scrollingOffset = calculateScrollingOffset(containerRef.current, stickyRef.current);
        if (scrollingOffset > 0) {
            scrollUpBy(scrollingOffset, containerRef.current);
        }
    };
    var scrollToItem = function (item) {
        if (!item || !containerRef.current || !stickyRef.current) {
            return;
        }
        var stickyBottom = stickyRef.current.getBoundingClientRect().bottom;
        var scrollingOffset = stickyBottom - item.getBoundingClientRect().top;
        if (scrollingOffset > 0) {
            scrollUpBy(scrollingOffset, containerRef.current);
        }
    };
    return {
        scrollToTop: scrollToTop,
        scrollToItem: scrollToItem
    };
}
export function calculateScrollingOffset(container, sticky) {
    var stickyRect = sticky.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();
    return stickyRect.top - containerRect.top;
}
export function scrollUpBy(amount, container) {
    var parent = getOverflowParents(container);
    if (parent.length) {
        parent[0].scrollTop -= amount;
    }
    else {
        window.scrollTo({ top: window.pageYOffset - amount });
    }
}
